import ApiService from "./api.service";


const Misc = {
//   loadCompany: async function () {
//     let response = await ApiService.get("/companies");
//     return response.data;
//   },
  loadPositions: async function () {
    let response = await ApiService.get("/positions");
    return response.data.positions;
  },
  loadAvailableEmployees: async function () {
    let response = await ApiService.get("employees/available");
    return response.data.employees;
  },
  loadAvailableCustomers: async function(){
    let response = await ApiService.get("customers/available");
    return response.data.customers;
  },
  loadConstructionFilesCategories: async function () {
    let response = await ApiService.get("/construction/files_categories");
    return response.data.filesCategories;
  },
  loadAvailablePositions: async function(){
    let response = await ApiService.get("positions/subcontractors");
    return response.data.positions;
  },
//   updateCompany: async function (form) {
//     let response = await ApiService.put("/companies", form, "The company info has been updated");
//     return response.data;
//   }
};

export default Misc;